// extracted by mini-css-extract-plugin
module.exports = {"widgetErrorContainer":"WidgetInitialError_widgetErrorContainer__1Qwwp","subContainer":"WidgetInitialError_subContainer__1j3TN"};